import Model from './Model'
import Comment from '@/models/Comment'

export default class ResourceVideo extends Model {
  resource() {
    return 'videos'
  }

  comments() {
    return this.hasMany(Comment)
  }

  get isYoutube() {
    return (
      this.video_url.includes('youtube') || this.video_url.includes('youtu.be')
    )
  }

  get isVimeo() {
    return this.video_url.includes('vimeo')
  }
}
